export enum EULA_SERVICE_NAME {
  MIMS = 'MIMS',
  RX_PAD = 'Rxpad',
}
